
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";

  @Component({
    components: {
      ModalSectionsDivider,
    },
  })
  export default class ModalHeader extends Vue {
    @Prop({ type: String, default: "" }) readonly title!: string;
    @Prop({ type: Boolean, default: false }) readonly columnLayout!: boolean;
    @Prop({ type: Boolean, default: false }) readonly showCustomTitle!: boolean;
    @Prop({ type: Boolean, default: false }) readonly fullWidth!: boolean;

    get styles(): object {
      return {
        "justify-between": !this.columnLayout,
        "flex-col": this.columnLayout,
        "w-full": this.fullWidth,
      };
    }
  }
